/**
 * AbortNotifier is a simplified implementation of AbortController,
 * made for use with older browsers which do not support AbortController.
 *
 * Once we drop support for those older browsers, this class should be deleted
 * and all usage migrated to use AbortController and AbortSignal.
 */

export interface ReadonlyAbortNotifier<Reason> {
  readonly aborted: boolean;
  readonly reason: Reason | undefined;
  addAbortListener(callback: () => void): void;
}

export class AbortNotifier<Reason> implements ReadonlyAbortNotifier<Reason> {
  private _aborted: boolean = false;
  private _reason: Reason | undefined;

  private listeners: Array<() => void> = [];

  abort = (reason?: Reason) => {
    if (this._aborted) {
      return;
    }

    this._aborted = true;
    this._reason = reason;
    this.listeners.forEach((callback) => {
      callback();
    });
    this.listeners = [];
  };

  get aborted(): boolean {
    return this._aborted;
  }

  get reason(): Reason | undefined {
    return this._reason;
  }

  addAbortListener = (callback: () => void): void => {
    if (this._aborted) {
      return;
    }

    this.listeners.push(callback);
  };
}
